var map = {
	"./css.svg": "e22c",
	"./csv.svg": "47bc",
	"./doc.svg": "63c6",
	"./html.svg": "b24d",
	"./javascript.svg": "a2c6",
	"./jpg.svg": "80dd",
	"./mp4.svg": "e641",
	"./pdf.svg": "c1f8",
	"./ted.svg": "c4e1",
	"./xml.svg": "7fd9",
	"./zip.svg": "dcf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b703";